import React, {
    useEffect,
    useState,
    useMemo, useContext, useCallback,
} from 'react';

import PropTypes from 'prop-types';
import axios from "axios";
import AuthContext from "../../AuthContext";
import IndicatorsContext from "./IndicatorsContext";

const IndicatorsContextProvider = ({
                                   children,
                               }) => {

    const {authToken} = useContext(AuthContext)
    const [isReady, setIsReady] = useState(null)

    const [adviserQuotations, setAdviserQuotations] = useState(null);
    const [totalQuotations, setTotalQuotations] = useState(null);
    const [adviserEmissions, setAdviserEmissions] = useState(null);
    const [totalEmissions, setTotalEmissions] = useState(null);
    const [adviserConversion, setAdviserConversion] = useState(null);
    const [totalConversion, setTotalConversion] = useState(null);
    const [adviserAverageQuota, setAdviserAverageQuota] = useState(null);
    const [totalAverageQuota, setTotalAverageQuota] = useState(null);

    const [advisersEmissionRanking, setAdvisersEmissionRanking] = useState(null);
    const [affinitiesEmissionRanking, setAffinitiesEmissionRanking] = useState(null);

    const [modified, setModified] = useState(false);
    const handleModified = useCallback(() => {
        setModified(!modified)
    }, [modified]);

    useEffect(() => {
        let shouldUpdate = true;
        //
        const init = async () => {

            let url = process.env.REACT_APP_BACK_SERVER + '/u/getDatosIndicadores'

            axios.post(url, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                }
            }).then((resp) => {
                if (shouldUpdate) {
                    resp = resp['data']

                    setAdviserQuotations(resp['cotizaciones_mes_asesor'])
                    setTotalQuotations(resp['total_cotizaciones_mes'])
                    setAdviserEmissions(resp['emisiones_mes_asesor'])
                    setTotalEmissions(resp['total_emisiones_mes'])
                    setAdviserConversion(`${(resp['indicador_conversion_asesor']*100).toFixed(1)}%`)
                    setTotalConversion(`${(resp['indicador_conversion_total']*100).toFixed(1)}%`)
                    setAdviserAverageQuota(`$ ${resp['valor_cuota_promedio_asesor'].toFixed(1)}`)
                    setTotalAverageQuota(`$ ${resp['valor_cuota_promedio_total'].toFixed(1)}`)

                    setAdvisersEmissionRanking(resp['ranking_emisiones_asesores'])
                    setAffinitiesEmissionRanking(resp['afinidades_emitidas_asesor'])

                    setIsReady(true);
                }

            })

        }

        init();
        return () => {
            /* This cleanup function is used to prevent updating the state
            when the component is unmounted */
            shouldUpdate = false;
        };

    }, [modified])

    const context = useMemo(() => ({
        adviserQuotations,
        totalQuotations,
        adviserEmissions,
        totalEmissions,
        adviserConversion,
        totalConversion,
        adviserAverageQuota,
        totalAverageQuota,
        advisersEmissionRanking,
        affinitiesEmissionRanking,
        handleModified,
        isReady,
    }), [
        adviserQuotations,
        totalQuotations,
        adviserEmissions,
        totalEmissions,
        adviserConversion,
        totalConversion,
        adviserAverageQuota,
        totalAverageQuota,
        advisersEmissionRanking,
        affinitiesEmissionRanking,
        handleModified,
        isReady,
    ]);
    return (
        <IndicatorsContext.Provider value={context}>
            {children}
        </IndicatorsContext.Provider>
    );
}
IndicatorsContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default IndicatorsContextProvider;